import favouritesStateChangedHandler from "./FavouritesStateChangedHandler";
import votesStateChangedHandler from "./VotesStateChangedHandler";

export default [favouritesStateChangedHandler, votesStateChangedHandler];
